import { render, staticRenderFns } from "./ModalRemoverDaPasta.vue?vue&type=template&id=80ffe5e2&scoped=true"
import script from "./ModalRemoverDaPasta.vue?vue&type=script&lang=js"
export * from "./ModalRemoverDaPasta.vue?vue&type=script&lang=js"
import style0 from "./ModalRemoverDaPasta.vue?vue&type=style&index=0&id=80ffe5e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ffe5e2",
  null
  
)

export default component.exports